const RecycleBin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill={props.fill ? props.fill : '#437EF7'}
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    className={`${props.className ? props.className : 'hover:fill-white'}`}
  >
    <path
      fillRule="evenodd"
      d="M4.375 3.125h-2.5a.625.625 0 1 0 0 1.25H2.5V12.5c0 1.036.84 1.875 1.875 1.875h6.25c1.036 0 1.875-.84 1.875-1.875V4.375h.625a.625.625 0 1 0 0-1.25h-2.5V2.5c0-1.036-.84-1.875-1.875-1.875h-2.5c-1.036 0-1.875.84-1.875 1.875v.625Zm1.25 0h3.75V2.5a.625.625 0 0 0-.625-.625h-2.5a.625.625 0 0 0-.625.625v.625ZM10 4.375H3.75V12.5c0 .345.28.625.625.625h6.25c.345 0 .625-.28.625-.625V4.375H10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default RecycleBin;
